<template>
  <div class="not-found">
    <div class="not-found__content">
      <h1 class="not-found__heading">404</h1>
      <p>Page not found.</p>
      <p class="margin-top-xxl"><router-link class="btn btn--inverse btn--inline" :to="{name: 'home'}">Back to myBOOM Studio home</router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped>
.not-found {
  padding-top: 100px;
  min-height: 100vh;
  box-sizing: border-box;
  padding-left: 1em;
  padding-right: 1em;
  &__content {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 1.5em;
  }
  &__heading {
    text-transform: uppercase;
    font-size: 3em;
    margin-bottom: 0.25em;
  }
}
.btn {
  font-size: 0.85rem;
  margin-top: 2em;
  &--inline {
    display: inline-block;
  }
}
</style>